import React, { useEffect, useState } from 'react'
import { wholesaleGallery } from './content'
import type { Lang } from './types'

interface Props {
  currentLang: Lang
}

/**
 * Full-bleed image slider — auto-advancing, dot indicators below.
 * Mirrors the Barista Map wholesale 4-image rotator.
 */
const WholesaleGallerySliderV2: React.FC<Props> = ({ currentLang }) => {
  const [idx, setIdx] = useState(0)

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % wholesaleGallery.length)
    }, 4500)
    return () => clearInterval(t)
  }, [])

  return (
    <section className="bg-white">
      <div className="relative h-[60vh] min-h-[420px] w-full overflow-hidden bg-black">
        {wholesaleGallery.map((img, i) => (
          <div
            key={i}
            className={`absolute inset-0 transition-opacity duration-1000 ease-out ${
              idx === i ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={img.src}
              alt={img.caption[currentLang]}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-black/55 to-transparent" />
            <p
              className="absolute bottom-6 left-6 text-white md:bottom-8 md:left-10"
              style={{
                fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
                fontWeight: 400,
                fontSize: '14px',
                letterSpacing: '0.18em',
              }}
            >
              {img.caption[currentLang]}
            </p>
          </div>
        ))}

        {/* Dots */}
        <div className="absolute bottom-6 right-6 z-10 flex gap-3 md:bottom-8 md:right-10">
          {wholesaleGallery.map((_, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setIdx(i)}
              className="h-1.5 transition-all"
              style={{
                width: idx === i ? 28 : 14,
                backgroundColor:
                  idx === i ? 'rgba(255,255,255,0.95)' : 'rgba(255,255,255,0.45)',
              }}
              aria-label={`Slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default WholesaleGallerySliderV2
